/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Scope_Item_4Inputs */

const es_privacy_policy_scope_item_4 = /** @type {(inputs: Privacy_Policy_Scope_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunicaciones entre usted y nuestro equipo de soporte`)
};

const en_privacy_policy_scope_item_4 = /** @type {(inputs: Privacy_Policy_Scope_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communications between you and our support team`)
};

/**
* | output |
* | --- |
* | "Communications between you and our support team" |
*
* @param {Privacy_Policy_Scope_Item_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_scope_item_4 = /** @type {((inputs?: Privacy_Policy_Scope_Item_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Scope_Item_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_scope_item_4(inputs)
	return en_privacy_policy_scope_item_4(inputs)
});
export { privacy_policy_scope_item_4 as "privacy_policy.scope.item_4" }